NtechApp.Filters = function($view, snapFilters) {
    var me = this;

    this._$view = null;
    this._snapFilters = null;

    this._click = null;
    this._removeScrollOnMobilesTimeout = null;
    this._addScrollOnMobilesTimeout = null;
    this._mainFormScrollLocker = null;

    this._construct = function () {
        me._$view = $view;
        me._snapFilters = snapFilters || false;
        me._click = new NtechApp.TouchClickEvent();

        me._mainFormScrollLocker = NtechApp.lockMobileScroll(me._$view);
        $.each(me._$view.find(".allFilter"), function() {
            NtechApp.lockMobileScroll($(this));
        });

        me._updateFormWidths();
        me._updateFormHeights();
        me._updateMainFormScrollLock();
        me._updateAllFiltersAfterInit();
        me._snapFiltersToViewportTop();

        me._bindEvents();
    }

    this._bindEvents = function () {
        var openSubfiltersForm = function(event) {
            me._mainFormScrollLocker.disableLock();
            // This is required to show overlayed forms
            clearTimeout(me._removeScrollOnMobilesTimeout);

            me._addScrollOnMobilesTimeout = setTimeout(function() {
                me._$view.addClass("hideScrollOnMobiles");
                if(NtechApp.isDesktop())
                    window.NtechApp.scrollToPx(0);
            }, 100);

            var $filtersGroup = $(event.target).closest(".filtersGroupHeading");
            var filtersGroup = $filtersGroup.attr("data-filtersGroup");

            var $filtersGroupForm = me._$view.find("[data-filtersGroupForm=" + filtersGroup + "]");
            $filtersGroupForm.addClass("openedFilter");
        };

        me._click.listen(me._$view.find(".viewContent"), ".right", function(event) {
            if(NtechApp.isMobile())
                return;

            openSubfiltersForm(event);
        });

        me._click.listen(me._$view.find(".filtersGroupHeading"), function(event) {
            if(NtechApp.isDesktop())
                return;

            openSubfiltersForm(event);
        });

        me._click.listen(me._$view.find(".allFilter"), ".closeButton", function(event) {
            var $form = $(event.target).closest(".allFilter");
            $form.removeClass("openedFilter");

            clearTimeout(me._addScrollOnMobilesTimeout);
            me._$view.scrollTop(0);

            me._removeScrollOnMobilesTimeout = setTimeout(function() {
                me._mainFormScrollLocker.enableLock();
                me._$view.removeClass("hideScrollOnMobiles");
                me._$view.scrollTop(0);
            }, 300);
        });

        $(window).on(NtechApp.Filters.EVENT_FILTERS_RESIZE, function() {
            $(me).trigger(NtechApp.Filters.EVENT_BEFORE_FILTERS_RESIZE);

            me._updateFormWidths();
            me._updateFormHeights();
            me._updateMainFormScrollLock();
            me._snapFiltersToViewportTop();
        });

        $(document).on(NtechApp.Filters.EVENT_DOCUMENT_SCROLL, function() {
            me._snapFiltersToViewportTop();
        });

        me._click.listen(me._$view, "[data-filterId]", function(event) {
            me._processFilterSelect(event);
        });

        //$(window).on(NtechApp.SearchLauncher.EVENT_SELECT, function(event, eventData) {
        me._click.listen($("body"), "[data-triggerOpenMobileFilters]", function(e) {
            me.openOnMobiles();
        });

        me._click.listen(me._$view.find(".mobileTop"), function() {
            me.closeOnMobiles();
        });
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.Filters.EVENT_FILTERS_RESIZE = "resize.NtechApp.Filters";
NtechApp.Filters.EVENT_BEFORE_FILTERS_RESIZE = "beforeResize.NtechApp.Filters";
NtechApp.Filters.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.Filters";
NtechApp.Filters.EVENT_FILTER_CHANGE = "NtechApp.Filters.FilterChange";
NtechApp.Filters.SNAP_TO_VIEWPORT = true;

NtechApp.proto(NtechApp.Filters, {
    getView: function() {
        return this._$view;
    },

    _snapFiltersToViewportTop: function() {
        //return; // Disable snapping
        if(!this._snapFilters)
            return;

        if(NtechApp.isMobile()) {
            this._$view.find(".viewContent").css({
                position: "static",
                top: "auto"
            });
            return;
        }

        var headingHeight = 0;

        $.each(this._$view.find("[data-viewHeadingItem]"), function() {
            headingHeight += $(this).outerHeight();
        });

        var $viewContent = this._$view.find("> .viewContent");

        if($(document).scrollTop() < headingHeight) {
            $viewContent.css({
                position: "static",
                top: "auto"
            });
            return;
        }
        else {
            var mainMenuHeight = 65;
            var newHeight = $(document).scrollTop() + mainMenuHeight + $viewContent.outerHeight();

            //if(newHeight > this._lastDocumentHeight) {
            var contentOverflow = mainMenuHeight + 10;
            if($viewContent.outerHeight() + contentOverflow > $(window).height()) {
                //var top = this._lastDocumentHeight - mainMenuHeight - $viewContent.outerHeight();
                $viewContent.css({
                    position: "static",
                    top: "auto"
                });
                return;
            }
            else
                var top = $(document).scrollTop();

            $viewContent.css({
                position: "absolute",
                top: top + "px"
            });
        }
    },

    _updateAllFiltersAfterInit: function() {
        var $filters = this._$view.find("[data-filterId]");
        var $oneFilterFromEachGroup = $();

        $.each($filters, function() {
            var addFilterFromNewGroup = false;
            var $filter = $(this);

            if(NtechApp.dom.hasAttribute($filter.get(0), "data-filterGroup")) {
                if($oneFilterFromEachGroup.length == 0)
                    addFilterFromNewGroup = true;
                else {
                    addFilterFromNewGroup = true;
                    $.each($oneFilterFromEachGroup, function () {
                        if($(this).attr("data-filterGroup") == $filter.attr("data-filterGroup"))
                            addFilterFromNewGroup = false;
                    });
                }
            }

            if(addFilterFromNewGroup)
                $oneFilterFromEachGroup = $oneFilterFromEachGroup.add($filter);
        });

        var me = this;
        $.each($oneFilterFromEachGroup, function() {
            me._updateAllFiltersOnFilterSelect($(this));
        });
    },

    _isAnyAllFilterFormOpened: function() {
        var isAnyOpened = false;

        $.each(this._$view.find(".allFilter"), function() {
            if($(this).hasClass("openedFilter"))
                isAnyOpened = true;
        });

        return isAnyOpened;
    },

    _updateFormWidths: function() {
        var subforms = [];
        $.each(this._$view.find(".allFilter"), function() {
            subforms.push($(this).get(0));
        });

        var vpWidth = $(window).width() + "px";
        var newWidth = (NtechApp.isMobile599() && NtechApp.isPortrait()) ? vpWidth : "";
        for(var i = 0; i < subforms.length; i++)
            subforms[i].style.width = newWidth;
    },

    _updateFormHeights: function() {
        //var headerHeight = 65;
        //var formHeight = $(document).height() - headerHeight;
        var $mapView = $("body").find("#mapView");
        var formHeight = 0;

        formHeight += $mapView.find(".mapControls").outerHeight();
        formHeight += $mapView.find(".mapView").outerHeight();
        formHeight += $mapView.find("#footer").outerHeight();

        // Form height cannot be smaller than it's content height
        var mainFormHeight = this._findMainFormContentHeight();
        var subformHeights = this._findSubformContentHeights();

        var allFormHeights = subformHeights;
        allFormHeights.push(mainFormHeight);

        for(var i = 0; i < allFormHeights.length; i++) {
            if(allFormHeights[i] > formHeight)
                formHeight = allFormHeights[i];
        }

        var footerAdditionalSpacer = 2;
        formHeight += footerAdditionalSpacer;

        this._$view.css("height", formHeight + "px");
        $.each(this._$view.find(".allFilter"), function() {
            $(this).css("height", formHeight + "px");
        });
    },

    _findMainFormContentHeight: function() {
        var mainFormHeight = 0;
        $.each(this._$view.find("[data-viewheadingitem]"), function() {
            mainFormHeight += $(this).outerHeight();
        });
        mainFormHeight += this._$view.find("> .viewContent").outerHeight();

        return mainFormHeight;
    },

    _findSubformContentHeights: function() {
        var subformHeights = [];
        $.each(this._$view.find(".allFilter"), function() {
            var height = 0;
            $.each($(this).children(), function() {
                height += $(this).outerHeight();
            });

            subformHeights.push(height);
        });

        return subformHeights;
    },

    _updateMainFormScrollLock: function() {
        if(this._isAnyAllFilterFormOpened()) {
            return;
        }

        if(NtechApp.isMobile())
            this._mainFormScrollLocker.enableLock();
        else
            this._mainFormScrollLocker.disableLock();
    },

    _processFilterSelect: function(event) {
        var me = this;

        var $filter = $(event.target).closest("[data-filterId]");
        var filterId = $filter.attr("data-filterId");

        if(filterId == "All") {
            if(NtechApp.dom.hasAttribute($filter.get(0), "data-filterSubgroupAll"))
                me._processAllFilterSelectWithSubfilter($filter);
            else
                me._processAllFilterSelect($filter);
        }
        else {
            var $filters = me._$view.find("[data-filterId=" + filterId + "]");
            if($filter.hasClass("selected"))
                $filters.removeClass("selected");
            else
                $filters.addClass("selected");

            me._updateAllFiltersOnFilterSelect($filter);
        }

        $(me).trigger(NtechApp.Filters.EVENT_FILTER_CHANGE, [me.getSelectedFilterData()]);
    },

    _processAllFilterSelectWithSubfilter: function($filter) {
        var me = this;

        var filterGroup = $filter.attr("data-filterGroupAll");
        var filterSubgroup = $filter.attr("data-filterSubgroupAll");

        if(filterSubgroup == "main") {
            var $allFilters = me._$view.find("[data-filterGroupAll=" + filterGroup + "]");
            var $filters = me._$view.find("[data-filterGroup=" + filterGroup + "]");

            //this._toggleFilterCss($allFilters, $filters);
            if($filter.hasClass("selected")) {
                $allFilters.removeClass("selected");
                $filters.removeClass("selected");
            }
            else {
                $allFilters.addClass("selected");
                $filters.addClass("selected");
            }
        }
        else {
            var $allFilters = me._$view.find("[data-filterGroupAll=" + filterGroup + "]");

            var $mainAllFilter = null;
            var $clickedAllFilter = null;
            var otherAllFilters = [];

            $.each($allFilters, function() {
                if($(this).attr("data-filterSubgroupAll") == "main")
                    $mainAllFilter = $(this);
                else if($(this).attr("data-filterSubgroupAll") == filterSubgroup)
                    $clickedAllFilter = $(this);
                else
                    otherAllFilters.push($(this));
            });

            var $subFilters = this._$view.find("[data-filterSubgroup=" + filterSubgroup + "]");
            var $filters = $();
            $.each($subFilters, function() {
                $filters = $filters.add(me._$view.find("[data-filterId=" + $(this).attr("data-filterId") + "]"));
            });

            this._toggleFilterCss($clickedAllFilter, $filters);

            var $allFormFilters = this._$view.find("[data-filterGroup=" + filterGroup + "]");
            var areAllSelected = true;

            $.each($allFormFilters, function() {
                if(!$(this).hasClass("selected"))
                    areAllSelected = false;
            });

            if(areAllSelected)
                $mainAllFilter.addClass("selected");
            else
                $mainAllFilter.removeClass("selected");
        }
    },

    _processAllFilterSelect: function($filter) {
        var me = this;

        var filterGroup = $filter.attr("data-filterGroupAll");
        var $allFilters = me._$view.find("[data-filterGroupAll=" + filterGroup + "]");
        var $filters = me._$view.find("[data-filterGroup=" + filterGroup + "]");

        this._toggleFilterCss($allFilters, $filters);
    },

    _toggleFilterCss: function($allFilters, $filters) {
        if($allFilters.hasClass("selected")) {
            $allFilters.removeClass("selected");
            $filters.removeClass("selected");
        }
        else {
            $allFilters.addClass("selected");
            $filters.addClass("selected");
        }
    },

    _updateAllFiltersOnFilterSelect: function($filter) {
        var me = this;
        var $allFilters = this._$view.find("[data-filterGroupAll=" + $filter.attr("data-filterGroup") + "]");

        var $mainAllFilter = null;
        var $otherAllFilters = $();

        $.each($allFilters, function() {
            if($(this).attr("data-filterSubgroupAll") == "main")
                $mainAllFilter = $(this);
            else
                $otherAllFilters = $otherAllFilters.add($(this));
        });

        // Default form(no subcats)
        if($mainAllFilter == null) {
            var filterGroup = $($otherAllFilters.get(0)).attr("data-filterGroupAll");
            var $dependedFilters = this._$view.find("[data-filterGroup=" + filterGroup + "]");

            this._updateAllFilterCssOnFilterSelect($otherAllFilters, $dependedFilters);
        }
        // Form with subcats
        else {
            var areAllSubcatsSelected = true;
            $.each($otherAllFilters, function() {
                var filterSubgroup = $(this).attr("data-filterSubgroupAll");
                var $dependedFilters = me._$view.find("[data-filterSubgroup=" + filterSubgroup + "]");

                var areAllSelected = me._updateAllFilterCssOnFilterSelect($(this), $dependedFilters);
                if(!areAllSelected)
                    areAllSubcatsSelected = false;
            });

            if(areAllSubcatsSelected)
                $mainAllFilter.addClass("selected");
            else
                $mainAllFilter.removeClass("selected");
        }
    },

    _updateAllFilterCssOnFilterSelect: function($allFilters, $dependedFilters) {
        var areAllSelected = true;

        $.each($dependedFilters, function() {
            if(!$(this).hasClass("selected"))
                areAllSelected = false;
        });

        if(areAllSelected)
            $allFilters.addClass("selected");
        else
            $allFilters.removeClass("selected");

        return areAllSelected;
    },

    getSelectedFilterData: function() {
        var filterData = {};
        $.each(this._$view.find("[data-filtersGroupForm]"), function() {
            var jobFilterType = $(this).attr("data-filtersGroupForm");
            filterData[jobFilterType] = [];

            $.each($(this).find("[data-filterId]"), function() {
                if(!$(this).hasClass("selected") || $(this).attr("data-filterId") == "All")
                    return;

                var filterId = $(this).attr("data-filterId");
                var hasFilterId = false;

                for(var i = 0; i < filterData[jobFilterType].length; i++) {
                    if(filterData[jobFilterType][i] == filterId) {
                        hasFilterId = true;
                        break;
                    }
                }

                if(!hasFilterId)
                    filterData[jobFilterType].push(filterId);
            });
        });

        return filterData;
    },

    openOnMobiles: function() {
        this._$view.addClass("openedFilters");
    },

    closeOnMobiles: function() {
        this._$view.removeClass("openedFilters");
    }
});